<template>
    <td>
        <i :class="iconClass" />
        {{ value }}
    </td>
</template>

<script>
export default {
    props: {
        data: Object,
        value: String,
    },
    computed: {
        iconClass() {
            return this.data.icons[this.value];
        },
    },
};
</script>
